import React, {ComponentType, useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {Player} from "~/types/player";
import {PlayerProfile, PlayerProfileProps} from "~/pages/player-profile/PlayerProfile";

const convertMetersToFeetInches = (r: number) => {
    const inchesInMeters = r * 39.37007874013;
    const feet = Math.floor(inchesInMeters / 12);
    const inches = inchesInMeters % 12;

}

export const playerEleea: Player = {
    id: '1111-1111-1111-1111',
    firstName: "Eleea",
    lastName: "Cairns",
    position: 'GK',
    gradYear: '2030',
    gender: 'female',
    socialMedia: {
        facebook: "ethan.cairns",
        x: "nahtecarnes",
    },
    contacts: [
        {
            name: "Ethan Cairns",
            email: 'ethan@gmail.com',
            phone: '405-570-1123',
        }
    ],
    physicalStats: {
        dominantHand: 'right',
        dominantFoot: 'right',
        height: 63.5,
        weight: 144,
        handSize: 9,
        wingSpan: 63.5,
    },
    academics: {
        gpa: 3.8,
        achievements: [
            {name: "National Honor Society", year: 2024},
            {name: "Academic All-State", year: 2023},
        ],
    },
    school: {
        name: "The Classical Academy",
        location: "Colorado Springs, CO",
    },
    location: 'Colorado Springs, CO',
    sports: [
        {
            type: "Soccer",
            positions: ['GK'],
            affiliations: [
                {
                    id: '1234-1234-1234-1234',
                    type: 'CLUB',
                    name: 'Colorado Rapids North ECNL RL G11',
                    link: {
                        href: 'https://rapidsyouthsoccer.org/elite/ecnl-regional-league-ecrl-national-premier-leagues-npl/',
                    },
                    player: {
                        id: '1111-1111-1111-1111',
                        image: {
                            src: 'https://s3.amazonaws.com/images.totalglobalsports.com/PlayerImage/Eleea_Cairns_5f8a666b3f8e453fb81f3b84cb250e02.jpeg'
                        }
                    },
                    isDefault: true,
                },
                {
                    id: '1235-1234-1234-1234',
                    type: 'CLUB',
                    name: 'Colorado Rush G11',
                    link: {
                        href: 'https://www.coloradorush.com/',
                    },
                    player: {
                        id: '1111-1111-1111-1111',
                        image: {
                            src: 'https://s3.amazonaws.com/images.totalglobalsports.com/PlayerImage/Eleea_Cairns_5f8a666b3f8e453fb81f3b84cb250e02.jpeg'
                        }
                    },
                    isDefault: false,
                },
            ],
        },
    ],
};

// Mock API call (replace with your actual API)
const fetchPlayerData = async (id: string): Promise<Player> => {
    // Simulated API call
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(playerEleea);
        }, 1000);
    });
};

export const withPlayerData = <P extends PlayerProfileProps>(
    WrappedComponent: ComponentType<P>
) => {
    const WithPlayerData: React.FC<Omit<P, 'player' | 'loading' | 'error'>> = (props) => {
        const {id, affiliation, sport} = useParams<{ id: string, affiliation: string, sport: string }>();
        const [player, setPlayer] = useState<Player | null>(null);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState<string | null>(null);

        useEffect(() => {
            const loadPlayer = async () => {
                if (!id) {
                    setError("No player ID provided");
                    setLoading(false);
                    return;
                }

                try {
                    setLoading(true);
                    const data = await fetchPlayerData(id);
                    setPlayer(data);
                    setError(null);
                } catch (err) {
                    setError("Failed to load player data");
                } finally {
                    setLoading(false);
                }
            };

            loadPlayer().then(r => console.log(r));
        }, [id]);

        return (
            <WrappedComponent
                {...(props as P)}
                player={player}
                affiliation={affiliation}
                sport={sport}
                loading={loading}
                error={error}
            />
        );
    };

    return WithPlayerData;
};

export default withPlayerData(PlayerProfile)